/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CancelProductionOrderPresetupEntry } from '../../models/cancel-production-order-presetup-entry';

export interface CancelProductionOrderPresetup$Params {
  productionOrderId: number;
      body: CancelProductionOrderPresetupEntry
}

export function cancelProductionOrderPresetup(http: HttpClient, rootUrl: string, params: CancelProductionOrderPresetup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, cancelProductionOrderPresetup.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

cancelProductionOrderPresetup.PATH = '/api/v1/ProductionOrder/{productionOrderId}/CancelPresetup';
